const codeBlocks = {
	'tabs-cb': (rdm, rcm)=> {return `
<div class="rwx-tabs" id="{{ UNIQUE ID }}" role="tablist" rwx-tabs>
	<div class="rwx-tabs-tab" data-rwx-tabs-title="{{ TAB TITLE }}" role="tabpanel">
		{{ TAB CONTENT}}
	</div>
	<div class="rwx-tabs-tab" data-rwx-tabs-title="{{ TAB TITLE }}" role="tabpanel">
		{{ TAB CONTENT }}
	</div>
</div>
	`},
	'slider-cb': (rdm, rcm)=> {return `
<div class="rwx-slider ${rcm || ''}" id="{{ UNIQUE ID }}" rwx-slider ${rdm || ''}>
	<div class="rwx-slider-slide"> 
		{{ SLIDE CONTENT }} 
	</div>
	<div class="rwx-slider-slide"> 
		{{ SLIDE CONTENT }} 
	</div>
</div>
	`},
	'forms-cb': (rdm,rcm)=> {return `
<form class="rwx-form" rwx-form>{{ FORM ITEMS }}</form>
	`},
	'forms-item-readonly-cb': (rdm, rcm)=> {return codeBlocks['forms-item-cb'](rdm,rcm,true)},
	'forms-item-cb': (rdm, rcm, readonly=false)=> {return `
<div class="rwx-form-item ${rcm || ''}"${readonly ? " readonly":''}>
	<input type="${rdm || ''}" name="{{ NAME OF FIELD }}" id="{{ UNIQUE ID }}" />
	<label for="{{ SAME ID AS INPUT }}">{{ LABEL TEXT }}</label>
	<p class="invalid-message">{{ INVALID MESSAGE TEXT }}</p>
</div>
	`},
	'forms-dropdown-cb': (rdm, rcm)=> {return `
<div class="rwx-form-item ${rcm || ''}">
	<select name="{{ NAME OF FIELD }}" id="{{ UNIQUE ID }}">
		<option value="{{ OPTION VALUE }}">{{ OPTION TEXT }}</option>
		<option value="{{ OPTION VALUE }}">{{ OPTION TEXT }}</option>
		<option value="{{ OPTION VALUE }}">{{ OPTION TEXT }}</option>
	</select>
	<label for="{{ SAME ID AS SELECT}}">{{ LABEL TEXT }}</label>
</div>
	`},
	'forms-radio-group-cb': (rdm, rcm)=> {return `
<div class="rwx-form-radio-group ${rcm || ''}" id="{{ UNIQUE ID }}}">
	<p>{{ RADIO GROUP LABEL TEXT }}</p>
	<div class="rwx-form-item">
		<input type="radio" name="{{ SAME NAME AS OTHER RADIO ITEMS IN SAME RADIO GROUP }}" id="{{ UNIQUE ID }}" />
		<label for="{{ SAME ID AS INPUT }}">{{ RADIO GROUP ITEM LABEL TEXT }}</label>
	</div>
	<div class="rwx-form-item">
		<input type="radio" name="{{ SAME NAME AS OTHER RADIO ITEMS IN SAME RADIO GROUP }}" id="{{ UNIQUE ID }}" />
		<label for="{{ SAME ID AS INPUT }}">{{ RADIO GROUP ITEM LABEL TEXT }}</label>
	</div>
	<div class="rwx-form-item">
		<input type="radio" name="{{ SAME NAME AS OTHER RADIO ITEMS IN SAME RADIO GROUP }}" id="{{ UNIQUE ID }}" />
		<label for="{{ SAME ID AS INPUT }}">{{ RADIO GROUP ITEM LABEL TEXT }}</label>
	</div>
</div>
	`},
	'forms-textarea-cb': (rdm, rcm)=> {return `
<div class="rwx-form-item">
	<textarea name="{{ NAME OF FIELD }}" id="{{ UNIQUE ID }}" rows="{{ HOW MANY ROWS OF TEXT }}"/>
	<label for="{{ SAME ID AS TEXTAREA }}">{{ LABEL TEXT }}</label>
	<p class="invalid-message">{{ INVALID MESSAGE TEXT }}</p>
</div>
	`},
	'forms-submit-button-cb': (rdm, rcm)=> {return `
<button type="submit">{{ SUBMIT FORM TEXT }}</button>
	`},
	'tables-cb': (rdm, rcm, x2=false, x3=false)=> { return `
<div class="rwx-table ${rcm || ''}" role="table" rwx-table>
	<div class="rwx-table-data" role="row">
		<span role="cell">{{ TABLE DATA TEXT }}</span>
		<span role="cell" ${x2 ? 'class="x2"' : ''}${x3 ? 'class="x3"' : ''}>{{ TABLE DATA TEXT }}</span>
	</div>
	<div class="rwx-table-data" role="row">
		<span role="cell">{{ TABLE DATA TEXT }}</span>
		<span role="cell" ${x2 ? 'class="x2"' : ''}${x3 ? 'class="x3"' : ''}>{{ TABLE DATA TEXT }}</span>
	</div>
	<div class="rwx-table-data" role="row">
		<span role="cell">{{ TABLE DATA TEXT }}</span>
		<span role="cell" ${x2 ? 'class="x2"' : ''}${x3 ? 'class="x3"' : ''}>{{ TABLE DATA TEXT }}</span>
	</div>	
</div>
	`},
	'tables-x2-cb': (rdm, rcm)=> { return codeBlocks['tables-cb'](rdm,rcm,true)},
	'tables-x3-cb': (rdm, rcm)=> { return codeBlocks['tables-cb'](rdm,rcm,false,true)}
}

export default codeBlocks;